import axios from 'axios';
import _ from 'underscore';
import getApiClient from 'shared/data/helpers/ApiClient';

const apiClient = getApiClient();

export default {
  // unused
  getItemRowTitles(teamId, eventId, showId, itemSetId) {
    return axios
      .post('/api/itemSetList.getItemRowTitles', {
        params: { teamId, eventId, showId, itemSetId },
      })
      .then((res) => res.data);
  },

  // gem modal
  moveFromTo(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    source,
    target,
  ) {
    return apiClient.itemSet.moveFromTo(
      teamId,
      eventId,
      showId,
      itemSetListId,
      itemSetId,
      { source, target },
    );
  },

  moveRows(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    rowIds,
    afterRowId,
  ) {
    return apiClient.itemSet.moveRows(teamId, eventId, showId, itemSetListId, {
      itemSetId,
      rowIds,
      afterRowId,
    });
  },

  // good
  updateMultipleItemRowCells(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    changes,
  ) {
    return apiClient.itemSet.updateMultipleItemRowCells(
      teamId,
      eventId,
      showId,
      itemSetListId,
      { itemSetId, changes },
    );
  },

  updateItemRowNote(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    rowId,
    userId,
    changes,
  ) {
    return apiClient.itemSet.updateItemRowNote(
      teamId,
      eventId,
      showId,
      itemSetListId,
      { itemSetId, rowId, userId, changes },
    );
  },

  convertToTitleRow(teamId, eventId, showId, itemSetListId, itemSetId, rowId) {
    return apiClient.itemSet.updateItemRowPresentation(
      teamId,
      eventId,
      showId,
      itemSetListId,
      {
        itemSetId,
        rowId,
        changes: {
          titleRow: true,
        },
      },
    );
  },

  updateRowLabels(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    rowId,
    changes,
  ) {
    // The labels endpoint accepts exactly { labels }; changes arrives as an
    // Immutable Map from the cuesheet stores.
    const labels =
      typeof changes.get === 'function'
        ? changes.get('labels')
        : changes.labels;

    return apiClient.itemSet.updateRowLabels(
      teamId,
      eventId,
      showId,
      itemSetListId,
      itemSetId,
      rowId,
      { labels },
    );
  },

  removeGlobalElementReference(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    rowId,
  ) {
    return apiClient.itemSet.removeGlobalElementReference(
      teamId,
      eventId,
      showId,
      itemSetListId,
      itemSetId,
      rowId,
    );
  },

  convertToStandardRow(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    rowId,
  ) {
    return apiClient.itemSet.updateItemRowPresentation(
      teamId,
      eventId,
      showId,
      itemSetListId,
      {
        itemSetId,
        rowId,
        changes: {
          titleRow: false,
        },
      },
    );
  },

  getProofsByGlobalElement(teamId, showId, itemSetId, rowId) {
    return axios
      .post('/api/itemSet.getProofsByGlobalElement', {
        params: { teamId, showId, itemSetId, rowId },
      })
      .then((res) => res.data);
  },

  createProofOfPerformance(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    rowId,
    note,
  ) {
    return axios
      .post('/api/itemSet.createItemRowProof', {
        params: { teamId, eventId, showId, itemSetListId },
        payload: { itemSetId, rowId, note },
      })
      .then((res) => res.data);
  },

  updateProofOfPerformanceNote(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    rowId,
    note,
  ) {
    return axios
      .post('/api/itemSet.updateItemRowProofNote', {
        params: { teamId, eventId, showId, itemSetListId },
        payload: { itemSetId, rowId, note },
      })
      .then((res) => res.data);
  },

  clearProofOfPerformance(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    rowId,
  ) {
    return axios
      .post('/api/itemSet.clearItemRowProof', {
        params: { teamId, eventId, showId, itemSetListId },
        payload: { itemSetId, rowId },
      })
      .then((res) => res.data);
  },

  clearProofOfPerformanceHistory(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    rowId,
  ) {
    return axios
      .post('/api/itemSet.clearItemRowProofHistory', {
        params: { teamId, eventId, showId, itemSetListId },
        payload: { itemSetId, rowId },
      })
      .then((res) => res.data);
  },

  getItemRowProofHistory(teamId, eventId, showId, itemSetId, rowId) {
    return axios
      .post('/api/itemSet.getItemRowProofHistory', {
        params: { teamId, eventId, showId, itemSetId, rowId },
      })
      .then((res) => res.data);
  },

  createItemRows(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    afterRowId,
    items,
    globalElement,
  ) {
    return apiClient.itemSet.createItemRows(
      teamId,
      eventId,
      showId,
      itemSetListId,
      { itemSetId, afterRowId, items },
      { globalElement },
    );
  },

  createGlobalElementItemRows(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    afterRowId,
    items,
  ) {
    return axios
      .post('/api/itemSet.createGlobalElementItemRows', {
        params: { teamId, eventId, showId, itemSetListId },
        payload: { itemSetId, afterRowId, items },
      })
      .then((res) => res.data);
  },

  createGlobalElementFromShowRow(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    labelIds,
    rows,
  ) {
    return axios
      .post('/api/itemSet.createGlobalElementFromShowRow', {
        params: { teamId, eventId, showId, itemSetListId, itemSetId },
        payload: {
          labels: labelIds,
          rows,
        },
      })
      .then((res) => res.data);
  },

  publishShowRowChangesEverywhereForGlobalElement(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    rowId,
    showIds,
    updateGlobalElementManager,
  ) {
    return axios
      .post('/api/itemSet.publishShowRowChangesEverywhereForGlobalElement', {
        params: { teamId, eventId, showId, itemSetListId, itemSetId, rowId },
        query: { shows: showIds, updateGlobalElementManager },
      })
      .then((res) => res.data);
  },

  publishGlobalElementChanges(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    rowId,
    showIds,
  ) {
    return axios
      .post('/api/itemSet.publishGlobalElementChanges', {
        params: { teamId, eventId, showId, itemSetListId, itemSetId, rowId },
        query: { shows: showIds },
      })
      .then((res) => res.data);
  },

  publishShowRowChangesToGlobalElementRow(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    rowId,
  ) {
    return axios
      .post('/api/itemSet.publishShowRowChangesToGlobalElementRow', {
        params: { teamId, eventId, showId, itemSetListId, itemSetId, rowId },
      })
      .then((res) => res.data);
  },

  retrieveLatestGlobalElementVersion(teamId, eventId, showId, globalElement) {
    let ge = _.omit(globalElement.toJS(), [
      '_id',
      '__v',
      'modifiedOn',
      'createdOn',
      'deleted',
    ]);

    return axios
      .post('/api/itemSet.publishLatestGlobalElementRowChangesToShowRow', {
        params: { teamId, eventId, showId },
        payload: { globalElement: ge },
      })
      .then((res) => res.data);
  },

  deleteActualDurations(teamId, eventId, showId, itemSetId, rowIds) {
    return apiClient.itemSet.deleteActualDurations(
      teamId,
      eventId,
      showId,
      itemSetId,
      rowIds ? { rowIds } : {},
    );
  },

  updateItemRow(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    rowId,
    changes,
  ) {
    return apiClient.itemSet.updateItemRow(
      teamId,
      eventId,
      showId,
      itemSetListId,
      { itemSetId, rowId, changes },
    );
  },

  updateItemRowSettings(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    rowId,
    rowIds,
    changes,
  ) {
    return apiClient.itemSet.updateItemRowSettings(
      teamId,
      eventId,
      showId,
      itemSetListId,
      { itemSetId, rowId, rowIds, changes },
    );
  },

  updateItemRowUserSettings(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    rowId,
    rowIds,
    userId,
    changes,
  ) {
    return apiClient.itemSet.updateItemRowUserSettings(
      teamId,
      eventId,
      showId,
      itemSetListId,
      { itemSetId, userId, rowId, rowIds, changes },
    );
  },

  softDeleteItemRows(
    teamId,
    eventId,
    showId,
    itemSetListId,
    itemSetId,
    rowIds,
    mode,
    globalElement,
  ) {
    return apiClient.itemSet.softDeleteItemRows(
      teamId,
      eventId,
      showId,
      itemSetListId,
      { itemSetId, rowIds, mode, globalElement },
    );
  },

  restoreItemRow(teamId, eventId, showId, itemSetListId, itemSetId, rowId) {
    return apiClient.itemSet.restoreItemRow(
      teamId,
      eventId,
      showId,
      itemSetListId,
      { itemSetId, rowId },
    );
  },
};
